<div class="container-onlineessay">
  <!-- Header Section -->
  <img src="../assets/images/dec-header.png" class="top" alt="Contest Header" />

  <!-- Flex Container for centering the form -->
  <div class="center-wrapper">
    <main class="form-container">
      <div class="header-content">
        <img src="../assets/images/dec-logo.jpg" alt="Contest Logo" class="logo" />
        <nav>
          <ul class="nav-links">
            <li><a href="#">Home</a></li>
            <!--<li *ngIf="multiAuthService.auth0Id">
              <a href="#" (click)="()=>{multiAuthService.logout(); localStorage.setItem('logout', 'logout');}">Logout</a>
            </li> -->
          </ul>
        </nav>
      </div>
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </main>
  </div>

  <!-- Buttons under the main container -->
  <div class="button-container">
    <button *ngIf="showBackButton" class="btn back" (click)="handleButton1()">Back</button>
    <button *ngIf="showNextButton" class="btn next" (click)="handleButton2()">Next</button>
  </div>
</div>
